import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {FilteredModel} from '../models/filteredModel';
import {GroupApplicantsModel} from '../models/groupApplicantsModel';
import { ScreeningLight, Screening } from '../models/screeningInvite';

@Injectable({
  providedIn: 'root'
})
export class GroupApplicantsService {

  private baseUrl = `${environment.baseURl}/api/GroupApplicant`;
  public groupScreenings : Screening[];
  constructor(public http: HttpClient) {

  }

  
  // public get groupedApplicants() : Screening[] {
  //   if(!this._groupScreenings) return [];
  //   else return this._groupScreenings.filter(g => g.id != this.screeningToEdit.id);
  // }

  // tslint:disable-next-line:max-line-length
  public getScreeningsForGroupList(locationId: number, take: number, searchFilterType: string, filter: string): Observable<FilteredModel[]> {
    return this.http.get<FilteredModel[]>(`${this.baseUrl}/GetScreeningsForGroupList/${locationId}?take=${take}&searchFilterType=${searchFilterType}&filter=${filter}`);
  }

  public getGroupedApplicants(groupId: string): Observable<FilteredModel[]> {
    return this.http.get<FilteredModel[]>(`${this.baseUrl}/getGroupedApplicants/${groupId}`);
  }

  public getGroupedScreenings(groupId: string): Observable<Screening[]> {
    this.groupScreenings = [];
    return this.http.get<Screening[]>(`${this.baseUrl}/getGroupedApplicants/screenings/${groupId}`);
  }

  public groupApplicants(applicantGroup: GroupApplicantsModel): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/GroupApplicants`, applicantGroup);
  }

  public unGroupApplicants(screening: ScreeningLight): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/UnGroupApplicants`, screening);
  }

  
}


